// Ingredient showcase. Names, images and the café's own descriptions come
// from the existing ingredients data. The nutrition numbers in that data were
// placeholder values, so they are replaced here with standard per-100 g
// reference values (USDA FoodData Central, raw/plain form). Branded premixes
// and pastes have no generic equivalent and show no nutrition until the pack
// label values are supplied.
import { IngredientItems } from "../../components/Ingredients/IngredientsData";

// [calories kcal, fat g, sodium mg, carbohydrates g] per 100 g
const per100g = {
  "Capsicum Red": [31, 0.3, 4, 6],
  "Capsicum Yellow": [27, 0.2, 2, 6.3],
  "Green Capsicum": [20, 0.2, 3, 4.6],
  "Sweet Corn": [86, 1.4, 15, 19],
  Tomato: [18, 0.2, 5, 3.9],
  Onion: [40, 0.1, 4, 9.3],
  "Chilli Flakes": [318, 17.3, 30, 56.6],
  Oregano: [265, 4.3, 25, 68.9],
  Chicken: [120, 2.6, 45, 0],
  Salt: [0, 0, 38758, 0],
  Lemon: [29, 0.3, 2, 9.3],
  "Mint Leaves": [44, 0.7, 31, 8.4],
  Paneer: [265, 20.8, 18, 1.2],
  Milk: [61, 3.3, 43, 4.8],
  "Mango Crush": [60, 0.4, 1, 15],
  "Black Raisin": [299, 0.5, 11, 79.2],
  "Cashew Nuts": [553, 43.9, 12, 30.2],
  "Almond Nuts": [579, 49.9, 1, 21.6],
  Oil: [884, 100, 0, 0],
  Kismis: [299, 0.5, 11, 79.2],
  "Coffee Powder": [353, 0.5, 37, 75.4],
  "Peanut Butter": [588, 50.4, 459, 20],
  "Cherries Fruit": [63, 0.2, 0, 16],
  "Chilli Powder": [318, 17.3, 30, 56.6],
  Honey: [304, 0, 4, 82.4],
};

const toNutrition = (v) =>
  v && [
    { name: "Calories", value: `${v[0]} kcal` },
    { name: "Fat", value: `${v[1]} g` },
    { name: "Sodium", value: `${v[2].toLocaleString("en-IN")} mg` },
    { name: "Carbohydrates", value: `${v[3]} g` },
  ];

export const ingredients = IngredientItems.map((i) => ({
  id: i.id,
  name: i.namer,
  image: i.image,
  paragraphs: [i.desc1, i.desc2].filter(Boolean),
  nutrition: toNutrition(per100g[i.namer]),
}));
